module.exports = __webpack_public_path__ + "media/images/upload-img-426140b2.png";